import Instagram from '../src/Instagram';
export default Instagram;
